import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { task as taskSchema } from '../lib/schema.js';
import { selectEntities } from './entities.js';

// API Actions

const RETRIEVE_TASKS_REQUEST = 'changesync/tasks/RETRIEVE_TASKS_REQUEST';
const RETRIEVE_TASKS_SUCCESS = 'changesync/tasks/RETRIEVE_TASKS_SUCCESS';
const RETRIEVE_TASKS_FAILURE = 'changesync/tasks/RETRIEVE_TASKS_FAILURE';
const CREATE_TASK_REQUEST = 'changesync/tasks/CREATE_TASK_REQUEST';
const CREATE_TASK_SUCCESS = 'changesync/tasks/CREATE_TASK_SUCCESS';
const CREATE_TASK_FAILURE = 'changesync/tasks/CREATE_TASK_FAILURE';
const UPDATE_TASK_REQUEST = 'changesync/tasks/UPDATE_TASK_REQUEST';
const UPDATE_TASK_SUCCESS = 'changesync/tasks/UPDATE_TASK_SUCCESS';
const UPDATE_TASK_FAILURE = 'changesync/tasks/UPDATE_TASK_FAILURE';
const DELETE_TASK_REQUEST = 'changesync/tasks/DELETE_TASK_REQUEST';
const DELETE_TASK_SUCCESS = 'changesync/tasks/DELETE_TASK_SUCCESS';
const DELETE_TASK_FAILURE = 'changesync/tasks/DELETE_TASK_FAILURE';

const initialState = {
  retrieveTasks: {
    pending: false,
    success: false,
    error: null,
  },

  tasksIds: {},
};

// Reducer

export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_TASKS_REQUEST:
      return {
        ...state,
        retrieveTasks: {
          ...state.retrieveTasks,
          pending: true,
          success: false,
          error: null,
        },
      };
    case RETRIEVE_TASKS_SUCCESS:
      return {
        ...state,
        retrieveTasks: {
          ...state.retrieveTasks,
          pending: false,
          success: true,
        },

        tasksIds: {
          ...state.tasksIds,
          [action.meta.changeImpactId]: action.payload.result,
        },
      };
    case RETRIEVE_TASKS_FAILURE:
      return {
        ...state,
        retrieveTasks: {
          ...state.retrieveTasks,
          pending: false,
          error: action.error,
        },
      };

    default:
      return state;
  }
};

export const retrieveTasks = (changeImpactId) => (dispatch) =>
  dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_TASKS_REQUEST,
        RETRIEVE_TASKS_SUCCESS,
        RETRIEVE_TASKS_FAILURE,
      ],
      endpoint: `change_impacts/${changeImpactId}/tasks`,
      method: HTTP_METHODS.GET,
      schema: [taskSchema],
    },
    meta: {
      changeImpactId,
    },
  });

export const createTask = (changeImpactId, task) => (dispatch) =>
  dispatch({
    [CALL_API]: {
      types: [CREATE_TASK_REQUEST, CREATE_TASK_SUCCESS, CREATE_TASK_FAILURE],
      endpoint: `change_impacts/${changeImpactId}/tasks`,
      method: HTTP_METHODS.POST,
      schema: taskSchema,
      body: { task },
    },
  });

export const updateTask = (taskId, task) => (dispatch) =>
  dispatch({
    [CALL_API]: {
      types: [UPDATE_TASK_REQUEST, UPDATE_TASK_SUCCESS, UPDATE_TASK_FAILURE],
      endpoint: `tasks/${taskId}`,
      method: HTTP_METHODS.PUT,
      body: { task },
    },
  });

export const deleteTask = (taskId) => (dispatch) => {
  return dispatch({
    [CALL_API]: {
      types: [DELETE_TASK_REQUEST, DELETE_TASK_SUCCESS, DELETE_TASK_FAILURE],
      endpoint: `tasks/${taskId}`,
      method: HTTP_METHODS.DELETE,
    },
  });
};

// Selectors

const selectTaskId = (_, props) => props.taskId;
const selectTasksIds = (state, props) =>
  state.tasks.tasksIds[props.changeImpactId];

export const selectRetrieveTasksState = (state) => state.tasks.retrieveTasks;

export const selectTasks = createSelector(
  selectTasksIds,
  selectEntities,
  (tasksIds, entities) => denormalize(tasksIds, [taskSchema], entities)
);

export const selectTask = createSelector(
  selectTaskId,
  selectEntities,
  (tasksId, entities) => denormalize(tasksId, taskSchema, entities)
);
